import {
    ChatMessagePill,
    NewMessagesLabel,
} from "@albertine/design-system/components/chat";
import { MessageScroller } from "@shadcn/react/message-scroller";
import { Lib, useAlbertineTranslation } from "albertine-shared-web";
import { AnimatePresence, motion } from "motion/react";
import type { ChatThreadDayGroup, ThreadItem } from "../-hooks/useChatThreadView";
import { useChatUnread } from "../-hooks/useChatUnreadMessages";
import { ThreadDayItem } from "./ThreadDayItem";

const newMessagesLabelTransition = {
    duration: 0.28,
    ease: [0.23, 1, 0.32, 1] as const,
};

const newMessagesLabelVariants = {
    hidden: { height: 0, opacity: 0 },
    visible: { height: "auto", opacity: 1 },
};

export function ThreadDayGroup({ group }: { group: ChatThreadDayGroup }) {
    return (
        <div className="flex flex-col gap-24">
            <ChatMessagePill text={Lib.Utils.TextFormatter.chat.datePill(group.date)} />

            {group.clusters.map((cluster) => (
                <div key={cluster[0]?.id} className="flex flex-col gap-4">
                    {cluster.map((item, index) => (
                        <div
                            key={item.id}
                            className="relative"
                            style={{ zIndex: cluster.length - index }}
                        >
                            <ThreadMessageEntry item={item} />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}

function ThreadMessageEntry({ item }: { item: ThreadItem }) {
    const t = useAlbertineTranslation();
    const { firstUnreadMessageId } = useChatUnread();
    const showNewMessagesLabel = item.id === firstUnreadMessageId;

    return (
        <>
            <AnimatePresence initial={false}>
                {showNewMessagesLabel ? (
                    <motion.div
                        key="new-messages-label"
                        initial={false}
                        animate="visible"
                        exit="hidden"
                        variants={newMessagesLabelVariants}
                        transition={newMessagesLabelTransition}
                        className="overflow-hidden"
                    >
                        <NewMessagesLabel>{t("chat.new_messages")}</NewMessagesLabel>
                    </motion.div>
                ) : null}
            </AnimatePresence>

            <MessageScroller.Item messageId={item.id}>
                <ThreadDayItem item={item} />
            </MessageScroller.Item>
        </>
    );
}
